import { Z_INDEX } from '~/src/styles/tokens/z-index';

export const notFoundIndex = Z_INDEX.bottom;

export const dropdownOffset = 4;

export enum StrategyEnum {
    PAGE = 'page',
    MODAL = 'modal',
}